"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import * as React from "react";
import type { ReactElement } from "react";

export function PostHogProvider({
  children,
}: Readonly<{
  children: ReactElement | ReactElement[];
}>) {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;

  React.useEffect(() => {
    if (!key || !host) {
      console.warn("PostHog environment variables not set");
      return;
    }

    if (process.env.NODE_ENV === "test") {
      return;
    }

    posthog.init(key, {
      api_host: host,
      autocapture: true,
      loaded: function (ph) {
        if (process.env.NODE_ENV !== "production") {
          ph.opt_out_capturing();
          ph.set_config({ disable_session_recording: true });
        }
      },
    });
  }, []);

  if (process.env.NODE_ENV !== "production") {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
